import { render, staticRenderFns } from "./AceMilesTransactionsHistory.vue?vue&type=template&id=76737cba&scoped=true&"
import script from "./AceMilesTransactionsHistory.vue?vue&type=script&lang=js&"
export * from "./AceMilesTransactionsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76737cba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
